import { ComponentProps } from "react";
import Card from "@particles/card/Card";
import { getWealthTopStoriesVariant } from "@routes/Section/layouts/Wealth/components/TopStories/utils/helpers";
import { cn } from "@util/helpers";

type WealthTopStoriesProps = {
  /** Optional className for the component */
  className?: string;
  /** The card props for the wealth top stories component */
  cardProps: ComponentProps<typeof Card>[];
};

/**
 * The wealth top stories component for the wealth page.
 * NO FIGMA LINK
 * */
const WealthTopStories = ({
  className,
  cardProps,
}: WealthTopStoriesProps): React.ReactElement => {
  return (
    <div
      data-testid="wealth-top-stories-component"
      className={cn(
        "stories grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-4",
        className
      )}
    >
      {cardProps.map((cardProp, index) => {
        const variant = getWealthTopStoriesVariant(index);

        return (
          <Card
            key={cardProp.id}
            {...cardProp}
            variations={variant}
            className={cn(
              "relative lg:flex-col",
              "after:absolute after:-bottom-3 after:left-0 after:right-0 after:h-[1px] after:bg-gray-175 md:after:hidden",
              "col-span-1",
              { "md:col-span-2 lg:col-span-4": index === 0 }
            )}
          />
        );
      })}
    </div>
  );
};

export default WealthTopStories;
